import { Icon } from '@smarterservices/smarter-ui';
import useSessionStore from '../../stores/session';
import { ButtonWithConfirmation } from '../../../../shared/components/Common/ButtonWithConfirmation';

/**
 * SessionHandRaise Component
 * 
 * Displays a hand icon when a student has raised their hand.
 * Clicking the icon shows a confirmation dialog to lower the hand.
 * 
 * @component
 * @param {Object} props
 * @param {string} props.sessionSid - Session identifier to check hand raised status
 * 
 * @example
 * <SessionHandRaise sessionSid="session_123" />
 */
function SessionHandRaise({ sessionSid }) {
    // Subscribe only to the handRaised for this specific session
    const handRaised = useSessionStore(
        (state) => state.sessions?.[sessionSid]?.handRaised || false
    );

    const lowerRaisedHand = useSessionStore((state) => state.lowerRaisedHand);

    // Don't render anything if hand is not raised
    if (!handRaised) {
        return null;
    }

    const handleLowerHand = () => {
        lowerRaisedHand({ sessionSid, reason: 'Manually lowered by proctor' });
    };

    return (
        <ButtonWithConfirmation
            onConfirm={handleLowerHand}
            confirmationText="Lower raised hand?"
            confirmButtonText="Yes"
            cancelButtonText="No"
            confirmButtonColor="danger"
            color="danger"
            size="small"
            margin="none none none x-small"
            screenReaderLabel="Test taker has raised hand - click to lower"
        >
            <Icon name="IconHandStop" size="x-small" />
        </ButtonWithConfirmation>
    );
}

export default SessionHandRaise;
